module.exports = __webpack_public_path__ + "static/media/Report.cf2b2d5a.png";